const navTogglers = document.querySelectorAll('.nav-link-toggle');

if (navTogglers) {
  navTogglers.forEach(function (navToggler) {
    navToggler.addEventListener("click", (event) => {
      let el= event.target;
      let openElements = document.querySelector('.nav-item--open');
      let closestNavItem = el.closest('.nav-item');

      let elIsOpen = false;
      if (closestNavItem.classList.contains('nav-item--open')) {
        elIsOpen = true;
      }

      if (elIsOpen) {
        closestNavItem.classList.remove('nav-item--open');
      } else {
        if (openElements) {
          openElements.classList.remove('nav-item--open');
        }
        closestNavItem.classList.add('nav-item--open');
      }
    });
  });
}

const mobileLevelTogglers = Array.from(document.querySelectorAll('.js-nav-panel-toggle'));

if (mobileLevelTogglers) {
  mobileLevelTogglers.forEach(function (mobileLevelToggler){
    mobileLevelToggler.addEventListener("click",  (event) => {
      const el = event.target;
      const closestButton = el.closest('.js-nav-panel-toggle');
      const toggleTargetId= closestButton.getAttribute('data-toggle-target');

      if (toggleTargetId) {
        const toggleTarget = document.querySelector(toggleTargetId);
        if (toggleTarget) {
          toggleTarget.classList.add('show');
        }
      }
    });
  });
}

const mobileLevelCloseTogglers = Array.from(document.querySelectorAll('.js-nav-link-panel-close'));

if (mobileLevelCloseTogglers) {
  mobileLevelCloseTogglers.forEach(function (mobileLevelCloseToggler){
    mobileLevelCloseToggler.addEventListener("click",  (event) => {
      event.preventDefault();
      const el = event.target;
      const currentPanel= el.closest('.js-mobile-menu-panel');

      if (currentPanel) {
        currentPanel.classList.remove('show');
      }
    });
  });
}

const mobileMenu = document.querySelector('.js-mobile-menu-panel');

if (mobileMenu) {
  mobileMenu.addEventListener("show.bs.collapse", (event) => {
    window.scroll(0,0);
    document.body.style.overflow = 'hidden';
  });

  mobileMenu.addEventListener("hide.bs.collapse", (event) => {
    document.body.style.overflow = 'auto';
  });
}
